import {ajaxGetData} from 'methods/ajaxData';
import PhoneAuthStep from './steps/phone-auth-step';

function AuthTypeTourist(modal) {
    this.modal = modal;
    this.title = 'Я турист';
    this.name  = 'tourist';
}

AuthTypeTourist.prototype.authorized = function() {
    return new Promise((resolve, reject) => {
        if (typeof this.authData != 'undefined') {
            resolve(this.authData);
            return;
        }

        ajaxGetData().then(r => {
            if (r.data.tourist_auth) {
                resolve(this.authData = this.getAuthFormatted(r.data.tourist_auth));
                return;
            }

            reject(`Not authorized as ${this.name}`);
        });
    });
}

AuthTypeTourist.prototype.auth = function(data) {
    return this.authorized().catch(() => {
        return this.modal.showStep(new PhoneAuthStep(this.modal))
            .auth(data)
            .then(auth => {
                return this.authData = this.getAuthFormatted(auth);
            });
    });
}

AuthTypeTourist.prototype.getAuthFormatted = function(data) {
    return Object.assign({}, data, {type: this.name});
}

export default AuthTypeTourist;
